<div>
    <!-- Event type -->
    @if (!this.eventFormStore.stepCategoryValid()) {
    <div>
        <h2>{{ "event_steps.step_category.label" | translate }}</h2>
        <div class="input-select-type">
            @for (eventType of streappService.eventTypes(); track eventType) {
            <event-type-selector [linkedEvent]="linkedEvent()" [eventType]="eventType"
                [selected]="eventType === selectedEvent()"
                (selectedEventType)="selectEventType($event)"></event-type-selector>
            }
        </div>
    </div>
    }
    <!-- Sub-Event Type -->
    @if (this.eventFormStore.stepCategoryValid() && selectedEvent()) {
    <div>
        <h2>{{ "event_steps.step_category.extra_step_label" | translate }}</h2>
        <div class="input-select-type">
            @for (eventType of selectedEvent()?.children; track eventType) {
            <event-type-selector [linkedEvent]="linkedEvent()" [eventType]="eventType"
                [selected]="eventType === selectedSubEvent()"
                (selectedEventType)="selectSubEventType($event)"></event-type-selector>
            }
        </div>
    </div>
    }
</div>